import { Injectable, signal, Signal } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ErrorDataService {
  private errorSignal = signal<HttpErrorResponse | null>(null);
  public currentError: Signal<HttpErrorResponse | null> = this.errorSignal.asReadonly();

  setError(error: HttpErrorResponse) {
    this.errorSignal.set(error);
  }

  clearError() {
    this.errorSignal.set(null);
  }
}
